import styled from '@emotion/styled';
import { gray } from '@kizen/kds/Colors';

export const Dot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
  background-color: ${({ color }) => color || gray['gray-600']};
`;

export default function ColorLabel({ color = null, children }) {
  return (
    <>
      <Dot color={color} />
      {children}
    </>
  );
}
